import React from 'react';
import logo from '../../assets/nuborrowLogo.svg';
import { StylableProp } from '../../utils/stylable-prop';
import { Link } from 'gatsby';

export default function NuborrowLogo(props: StylableProp) {
  return (
    <Link to="/" title="Go to Nuborrow.com">
      <img className={props.className} src={logo} alt="Nuborrow" />
      {/* <h1 className="pt-1 text-xs text-slate-600 md:text-sm lg:text-base">FSRA LIC 13115</h1> */}
    </Link>
  );
}
